// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__35s7Y","message":"CookieConsent_message__3Pu26","cookieLink":"CookieConsent_cookieLink__3qi0-","continueBtn":"CookieConsent_continueBtn__1OH9a"};